import submit from "submit-form";
import { useTranslation } from "react-i18next";

import Modal from "../../../../parts/modal-new";
import { getTestEmail } from "../../../../utils/user-helpers";
import { useRillContext } from "../../../../rill/RillReact/share/base";

const sendInvite = (e, email, googlePlayLink, appStoreLink) => {
  e.preventDefault();
  submit(`/coaching-portal/athletes/invite-athlete`, {
    method: "POST",
    body: {
      email,
      googlePlayLink,
      appStoreLink,
    },
  });
};

const TestAccountModal = (props) => {
  const { t } = useTranslation("coaching-portal");
  const { locals } = useRillContext();

  const testEmail = getTestEmail(locals.activeUser.email);
  const googlePlayLink =
    locals.activeUser.appStoreListingEnable && locals.activeUser.googlePlayLink
      ? locals.activeUser.googlePlayLink
      : "https://play.google.com/store/apps/details?id=com.mystrengthbook&hl=en_US&gl=US&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1";
  const appStoreLink =
    locals.activeUser.appStoreListingEnable && locals.activeUser.appStoreLink
      ? locals.activeUser.appStoreLink
      : "https://apps.apple.com/us/app/mystrengthbook/id1337179045";
  const referAsClients = locals.activeUser.referAsClients;
  const role = referAsClients
    ? t("athletes.roleClientLower")
    : t("athletes.roleAthleteLower");
  return (
    <Modal
      canClose={false}
      title={t("athletes.testAccountModal.title")}
      narrow
      className="test-account-modal"
    >
      <div className="body">
        <h4 className="mt-0 mb-6">
          {t("athletes.testAccountModal.checkEmailInbox")}
        </h4>
        <p className="p2 mb-4">
          {t("athletes.testAccountModal.testAsRole", { role })}{" "}
          {t("athletes.testAccountModal.afterSendingInvite")}{" "}
          <span className="text-(--information)">
            {locals.activeUser.email}
          </span>
          {t("athletes.testAccountModal.instructionsSuffix")}
        </p>
        <span className="chip info mb-2 h-8 py-0 ">
          {t("athletes.testAccountModal.testAccountEmail")} {testEmail}
        </span>
        <span className="chip warning h-8 py-0">
          {t("athletes.testAccountModal.notCharged")}
        </span>
      </div>
      <footer>
        <a
          role="button"
          data-button-type="primary"
          onClick={(e) =>
            sendInvite(e, testEmail, googlePlayLink, appStoreLink)
          }
        >
          {t("athletes.testAccountModal.sendInvite")}
        </a>
      </footer>
    </Modal>
  );
};

export default TestAccountModal;
